import DynamicFormChoiceResourceModel from '../../generated/types/model/resource/DynamicFormChoiceResourceModel';

export default class DynamicFormChoiceResourceViewModel extends DynamicFormChoiceResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
